import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TksSegurosComponent } from './thanks/tks-seguros/tks-seguros.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: '/home'
  // },
  {
    path: '',
    component: TksSegurosComponent,
    data: {
      title: 'Gracias Seguros'
    }
  },
  // {
  //   path: '*',
  //   redirectTo: '/home'
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
